module.exports = __webpack_public_path__ + "static/img/1960_04_10_NYHeraldTribune_PHLang_ThinkPiece.819a04d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cage/archive/1960_04_10_NYHeraldTribune_PHLang_ThinkPiece.jpg
// module id = khL5
// module chunks = 0